import {
  E2E_RENTAL_DETAILS_TAGS,
  E2E_RENTAL_DETAILS_TAGS_ADD,
  E2E_RENTAL_DETAILS_TAGS_REMOVE,
} from 'Constants/e2e'

import { EntityTagsInner } from './EntityTagsInner'
import type { Tag } from './tagging.types'

interface RentalTagsInnerProps {
  tags: Tag[]
  rentalId: string
  readOnly?: boolean
}

export const RentalTagsInner = (props: RentalTagsInnerProps) => {
  const { readOnly = false, rentalId, tags } = props

  return (
    <EntityTagsInner
      addDataE2e={E2E_RENTAL_DETAILS_TAGS_ADD}
      className="RentalTagsRow"
      detailsDataE2e={E2E_RENTAL_DETAILS_TAGS}
      entityId={rentalId}
      readOnly={readOnly}
      removeDataE2e={E2E_RENTAL_DETAILS_TAGS_REMOVE}
      tags={tags}
    />
  )
}
